import { render, staticRenderFns } from "./group-permissions.vue?vue&type=template&id=06f40b5e&"
import script from "./group-permissions.vue?vue&type=script&lang=js&"
export * from "./group-permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports